module.exports = __webpack_public_path__ + "static/darkAge-0c5401c5f19e91b7debcd8db389d4661.jpg";